import React from "react";
import { styled } from "@mui/material/styles";
import * as R from "ramda";
import Colors from "theme/tokens/colors";
import FileItem from "./file-item";
import {
  fileIsValid,
  getFileErrors,
} from "modules/representment/selectors/representment-selectors";
import Alert from "modules/shared/components/alert/alert";

const ONE_MILLION = 1000000;
const MAX_TOTAL_SIZE = 50;

const FileListContainer = styled("div")``;

const Typography = styled("p")`
  font-size: 14px;
  color: ${(props) => (props.color ? props.color : Colors.BASE_BLACK_500)};
  margin-bottom: 0;
`;

export default function FileList({
  title = "Os arquivos que você quer carregar aparecerão aqui.",
  files = [],
  onDelete = null,
  fetchState,
  apiResponse,
}) {
  const toMb = function (sizeInBytes) {
    return sizeInBytes === 0 ? 0 : R.divide(sizeInBytes, ONE_MILLION);
  };

  const getFilesSizeInMb = function (files) {
    const filesSize = R.map(R.prop("size"), files);
    const sum = R.reduce(R.add, 0, filesSize);
    return parseFloat(toMb(sum)).toFixed(2);
  };

  const filesSizeIsGreaterThanAllowed = function (files) {
    return getFilesSizeInMb(files) > MAX_TOTAL_SIZE;
  };

  const containErrors = function (errors, file) {
    return fileIsValid(errors, file);
  };

  const AlertWrapper = styled("div")`
    margin-top: 10px;
  `;

  const alertMessages = {
    success: "Arquivo enviado com sucesso!",
    error:
      "Não conseguimos enviar os arquivos para reapresentação. Certifique-se de que os tamanhos e nomes estão corretos antes de tentar novamente.",
  };

  return (
    <FileListContainer>
      <Typography>{title}</Typography>
      {fetchState === "error" && (
        <AlertWrapper>
          <Alert type="error"> {alertMessages.error} </Alert>
        </AlertWrapper>
      )}
      {fetchState !== "success" &&
        files.map((file, i) => (
          <FileItem
            key={`fileitem-${file.name}-${i}`}
            file={file}
            index={i}
            onDelete={onDelete}
            isValid={containErrors(apiResponse, file)}
            errors={getFileErrors(apiResponse, file)}
          ></FileItem>
        ))}
      {R.isEmpty(files) ? null : (
        <Typography
          color={
            filesSizeIsGreaterThanAllowed(files)
              ? Colors.CONTEXT_DANGER_200
              : Colors.BASE_GREY_400
          }
        >
          {getFilesSizeInMb(files)}MB de 50MB carregados
        </Typography>
      )}
    </FileListContainer>
  );
}
